export function CheckAltIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M18.49,2.12a1.41,1.41,0,0,0-2,.26L7.24,14.56,3.43,10.21A1.4,1.4,0,1,0,1.29,12l0,0,4.93,5.64a1.4,1.4,0,0,0,1,.48h.05a1.41,1.41,0,0,0,1.06-.55L18.75,4.08a1.4,1.4,0,0,0-.26-2Z" />
    </svg>
  )
}
